import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { RecordPage } from "./pages/RecordPage";
import { ReviewPage } from "./pages/ReviewPage";
import { LoginPage } from "./pages/LoginPage";
import { BrowsePage } from "./pages/BrowsePage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { ImpactPage } from "./pages/ImpactPage";
import { getSession, signOut } from "./services/auth";

function App() {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    getSession().then(() => setAuthed(true)).catch(() => {}).finally(() => setChecking(false));
  }, []);

  if (checking) return <p style={{ textAlign: "center", marginTop: 40 }}>Loading...</p>;
  if (!authed) return <LoginPage onSignIn={() => setAuthed(true)} />;

  return (
    <BrowserRouter>
      <nav style={{ display: "flex", gap: 16, padding: "12px 24px", background: "#1976d2", color: "#fff", alignItems: "center" }}>
        <strong>SOP Voice</strong>
        <Link to="/" style={{ color: "#fff" }}>Record</Link>
        <Link to="/review" style={{ color: "#fff" }}>Review</Link>
        <Link to="/browse" style={{ color: "#fff" }}>Browse</Link>
        <Link to="/analytics" style={{ color: "#fff" }}>Analytics</Link>
        <Link to="/impact" style={{ color: "#fff" }}>Impact</Link>
        <button onClick={() => { signOut(); setAuthed(false); }}
          style={{ marginLeft: "auto", background: "transparent", color: "#fff", border: "1px solid #fff", padding: "4px 12px", cursor: "pointer", borderRadius: 4 }}>
          Sign Out
        </button>
      </nav>
      <Routes>
        <Route path="/" element={<RecordPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/impact" element={<ImpactPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
